import { Component } from 'react';
import PropTypes from 'prop-types';

import { clone } from '../../../core/utils';
import { create, isValid } from '../../../components/form';
import { formatDate } from '../../../components/renderers';
import { makeSectionConfig, memberWizardFields } from './memberconfig';

class PersonalPanel extends Component<any, any> {
  static propTypes: any;
  static defaultProps: any;

  componentDidMount() {
    this.setValid(this.currentData());
  }

  currentData = () => {
    const { record = {}, data = {} } = this.props;
    return { ...record, ...(data.data || {}) };
  };

  formconfig = () =>
    makeSectionConfig('memberpersonal', 'Personal Details', memberWizardFields.personal);

  setValid = (data: any) => {
    const valid = isValid(this.formconfig(), data, 'add');
    if (typeof this.props.setValid === 'function') this.props.setValid(valid);
  };

  onChange = (name: any) => (value: any) => {
    const { data = {} } = this.props;
    const newdata = { ...(data.data || {}), [name]: value };
    this.setValid(newdata);
    this.props.setItem('data', 'data', newdata);
  };

  render() {
    const config = this.formconfig();
    const { classes, extras = {} } = this.props;
    const sconfig = clone(config);
    const sdata = sconfig.service;
    const mode = 'edit';
    const formatters = { ddb: formatDate };
    return create(mode, sdata, this.currentData(), formatters, this.onChange.bind(this), classes, extras);
  }
}

PersonalPanel.propTypes = {
  classes: PropTypes.object,
};

export default PersonalPanel;

